import type { ChatModelPolicy } from '@/store/chat-types'

export function buildStudioChatModelPolicy(
  role: ChatModelPolicy['role'] = 'studio-chat',
): ChatModelPolicy {
  return {
    provider: 'qwen',
    role,
    finalWriter: 'deterministic-cogo-compiler',
    mayPatchCogoJsonDirectly: false,
  }
}
